/**
 * Component responsible to add modal functionality using the modal component from garden.
 */
import $ from 'jquery'

import Modal from 'garden/src/js/components/modal'

export default ($el) => $el.modal({ triggerOpen: $el.data('trigger') })
